import React from 'react';
import styled from 'styled-components';

export const Row = styled.div<{margin?: string}>`
  margin: ${props => props.margin || '10px auto 0 auto'};
`;

const StyledTextInput = styled.input`
  font-size: 16px;
  border: 0;
  padding: 5px 10px;
  margin: 0px auto;
  width: 90%;
  display: block;
  resize: none;
  color: #444;
  font-size: 15px;
  line-height: 22px;
  font-family: inherit;
  background: #fff;
  color: #555;
  
  &:disabled {
    background: #FFF;
    color: #555;
  }
  
  &:focus {
    // border-bottom: 1px solid #ddd;
  }
`;

export const TextInput = ({ disabled=false, value, onChange }: { disabled?: boolean; value: string; onChange?: any }) => {
  return (
    <StyledTextInput disabled={disabled} type="text" onChange={onChange} value={value}/>
  )
}

const StyledTextAreaInput = styled.textarea`
  font-size: 16px;
  border: 0;
  padding: 5px 10px;
  margin: 0px auto;
  width: 90%;
  display: block;
  resize: none;
  color: #444;
  font-size: 15px;
  line-height: 22px;
  height: 100px;
  font-family: inherit;
  background: #fff;
  color: #555;
  
  &:hover {
    // border: 1px solid #ddd;
  }
  
  &:focus {
    // border: 1px solid #ddd;
  }
`;

export const TextAreaInput = ({ disabled=false, value, onChange }: { disabled?: boolean; value: string; onChange?: any }) => {
  return (
    <StyledTextAreaInput disabled={disabled} rows={4} value={value} onChange={onChange}></StyledTextAreaInput>
  )
}

export const Label = styled.div<{margin?: string}>`
  color: #333;
  text-align: left;
  margin: ${props => props.margin || '0 0 10px 0;'};
  font-size: 14px;
`;

export { VerticalSelect } from './VerticalSelect';